import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { ToolBar } from '@1c/ui';
import { FinalField, FinalForm } from 'src/components/FinalForm';
import Button from 'src/components/Button';
import InputField from 'src/components/InputField';
import Text from 'src/components/Text';
import { postSetPasswordAPI } from 'src/serverApi/account';
import { getLogoutAPI } from 'src/serverApi/authorization';
import validate from './validate';
import styles from './styles.module.scss';

type Props = {
  authorizationInfo?: {
    userId: string;
  };
  onSubmit: () => void;
}

const PasswordForm: React.FC<Props> = ({ authorizationInfo, onSubmit }) => {
  const [isLoading, setIsLoading] = useState(false);

  const setPassword = async (data: any) => {
    try {
      setIsLoading(true);
      await postSetPasswordAPI(data);
      onSubmit();
    } catch (error) {
      const { type } = error as any;
      const messages: { [key: string]: string } = {
        ['PASSWORD_FORMAT']:
          'Некорректный формат пароля. Есть пустые смволы в начале и/или в конце.',
        ['PASSWORD_IS_NOT_STRONG']: 'Пароль недостаточно сложный (менее 8 символов).',
      };
      toast.error(messages[type] || 'Произошла ошибка. Попробуйте позже.');
    } finally {
      setIsLoading(false);
    }
  };
  
  const logout = async () => {
    await getLogoutAPI();
    window.location.reload();
  }

  const handleSubmit = (values: any) => {
    setPassword(values?.password);
  };
  
  const handleBack = () => {
    logout();
  }

  return (
    <>
      <Text type="p" muted>Создайте пароль для входа по номеру {authorizationInfo?.userId || ''}</Text>
      <FinalForm
        onSubmit={handleSubmit}
        submitting={isLoading}
        pristine
        initialValues={{ password: undefined, confirmPassword: undefined }}
        validate={validate}
      >
        {({ submitting, pristine }: { submitting: any; pristine: any }) => {
          return (
            <div className={styles['form']}>
              <FinalField name="password">
                {({ onChange }: { onChange: any }) => (
                  <InputField
                    type="password"
                    label="Пароль"
                    onChange={onChange}
                    className={styles['input']}
                  />
                )}
              </FinalField>
              <FinalField name="confirmPassword">
                {({ onChange, error }: { onChange: any; error: string }) => (
                  <InputField
                    type="password"
                    label="Повторите пароль"
                    onChange={onChange}
                    className={styles['input']}
                    error={error}
                  />
                )}
              </FinalField>
              <ToolBar align="center" className={styles['buttons']}>
                <Button variant="text" disabled={submitting} onClick={handleBack}>
                  Назад
                </Button>
                <Button disabled={submitting || pristine} type="submit">
                  Продолжить
                </Button>
              </ToolBar>
            </div>
          );
        }}
      </FinalForm>
    </>
  );
};

export default PasswordForm;
